import { VulnerabilityField } from 'modules/cm/Vulnerabilities/Vulnerability';
import { format } from 'utils/date';
import { FormVulnerbaility } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/Vulnerabilities/Vulnerability';

const mapVulnerability = (formVulnerability: FormVulnerbaility): FormVulnerbaility => {
  const dateOfConsent = formVulnerability[VulnerabilityField.DateOfConsent];

  return {
    ...formVulnerability,
    dateOfConsent: dateOfConsent != null ? format(dateOfConsent).fromViewToRequest() : null,
  };
};

export default mapVulnerability;
